import { VideoView, useVideoPlayer } from "expo-video";
import { Modal, Pressable } from "react-native";
import { useEffect } from "react";

import { Col, Icon } from "../lib";
import { createStyles } from "../theme";

type Props = {
  url: string | null;
  onClose: () => void;
};

export function VideoPlayer({ url, onClose }: Props) {
  // Vars
  const player = useVideoPlayer(url);

  // Effects
  useEffect(() => {
    if (!player || !url) return;

    // Try to autoplay; many browsers require muted autoplay.
    try {
      //   player.muted = true;
      // play may return a promise
      player.play();
    } catch {
      // ignore playback errors
    }

    return () => {
      try {
        player.pause();
      } catch {
        // ignore
      }
    };
  }, [player, url]);

  // Render
  return (
    <Modal visible={!!url} onRequestClose={onClose} transparent>
      <Col.C style={$.overlay}>
        <Pressable onPress={onClose} style={$.closeButton}>
          <Icon large name="close" color="onOverlay" />
        </Pressable>

        <Col style={$.videoWrap}>
          <VideoView
            player={player}
            nativeControls
            contentFit="contain"
            style={$.video}
          />
        </Col>
      </Col.C>
    </Modal>
  );
}

const $ = createStyles({
  overlay: {
    flex: 1,
    backgroundColor: "overlay",
    p: "4",
  },
  closeButton: {
    position: "absolute",
    top: 20,
    right: 20,
  },
  videoWrap: {
    width: "100%",
    maxWidth: 1200,
    height: "80%",
    maxHeight: 800,
    roundness: "4",
    overflow: "hidden",
  },
  video: {
    width: "100%",
    height: "100%",
  },
});
